import { render } from "./PatientDocumentsTab.vue?vue&type=template&id=fd47ec9a"
import script from "./PatientDocumentsTab.vue?vue&type=script&lang=js"
export * from "./PatientDocumentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__